module.exports = __webpack_public_path__ + "img/btn1-2.e163411d.png";